import { WorkspaceConfig } from '../types/onboarding';

interface WorkspaceSetupProps {
  workspace: WorkspaceConfig;
  onComplete: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

interface WorkspaceRegistration {
  config: WorkspaceConfig;
  setupComponent: React.ComponentType<WorkspaceSetupProps>;
}

class WorkspaceRegistry {
  private workspaces: Map<string, WorkspaceRegistration> = new Map();

  register(
    config: WorkspaceConfig,
    setupComponent: React.ComponentType<WorkspaceSetupProps>,
  ) {
    this.workspaces.set(config.id, {
      config,
      setupComponent,
    });
  }

  getWorkspace(id: string): WorkspaceRegistration | undefined {
    return this.workspaces.get(id);
  }

  getAllWorkspaces(): WorkspaceConfig[] {
    return Array.from(this.workspaces.values()).map(
      (registration) => registration.config,
    );
  }

  getSetupComponent(
    id: string,
  ): React.ComponentType<WorkspaceSetupProps> | undefined {
    return this.workspaces.get(id)?.setupComponent;
  }
}

// Create a singleton instance
export const workspaceRegistry = new WorkspaceRegistry();

// Export types for consumers
export type { WorkspaceSetupProps };
